const ID_TOKEN_KEY = `cpe_token_content`;

export const getData = () => {
  // return window.$cookies.get(ID_TOKEN_KEY);
};

export const saveData = data => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export const destroyToken = () => {
  // window.localStorage.removeItem(ID_TOKEN_KEY);
};

export default { getData, saveData, destroyToken };
